var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-view',{attrs:{"headers":_vm.headers,"routes":_vm.routes,"url":_vm.url,"row-actions":_vm.rowActions,"top-actions":_vm.topActions,"sort-by":"name","title":"Places"}})}
var staticRenderFns = []

export { render, staticRenderFns }